import { COLORS } from '@btime/constants'
import { head, is } from 'ramda'
import { isBoolean } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import Tag from '../../components/presentation/Tag'

const formatValue = (operator, conditionValue) => {
  if (isBoolean(conditionValue)) return !!conditionValue ? 'Sim' : 'Não'
  if (['btwn', 'nbtween'].includes(operator) && is(Array, conditionValue)) return conditionValue.join(' e ')
  if (is(Array, conditionValue)) return conditionValue.join(', ')

  return conditionValue
}

const NonComplianceTag = ({ reply, ...props }) => {
  const { t } = useTranslation()
  const condition = head(reply.question?.nonComplianceConditions || [])
  const type = reply.question?.type?.name
  const { operator, value: conditionValue } = condition || {}
  const valueLabel = formatValue(operator, conditionValue)
  let label = `${t('conditions.operators.' + operator)} ${valueLabel}`

  if (type === 'select') label = 'Não conformidade'
  if (type === 'multiple') label = 'Não conformidade'

  return <Tag color={COLORS.red} {...props} label={label} />
}

export default NonComplianceTag
